export default __webpack_public_path__ + "static/media/EconomyVideo01.be37c736.mp4";